import { render, staticRenderFns } from "./HomeStaticContent.vue?vue&type=template&id=1cb92570&"
import script from "./HomeStaticContent.vue?vue&type=script&lang=ts&"
export * from "./HomeStaticContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports